<div class="wishlist-switch-overlay" *ngIf="showReplaceWishlistPopup" (click)="closeReplacePopup()"></div>
<div class="wishlist-switch-popup" *ngIf="showReplaceWishlistPopup">
  <!-- Fixed Header -->
  <div class="wishlist-switch-header">
    <button class="wishlist-switch-close-btn" (click)="closeReplacePopup()">✕</button>

    <div class="wishlist-switch-icon">
      <img src="../../../../assets/images/replace-req-pop-up-img.png">
    </div>

    <h2>You've Changed the Car</h2>

   <p class="wishlist-switch-subtitle">
      This Request Wishlist already contains items from another car.
      <br>
      Autoverse allows items from only one car in the Request Wishlist at a time.
   </p>
  </div>

  <!-- Scrollable Middle -->
  <div class="wishlist-switch-scroll">

    <!-- Current Car in Wishlist -->
    <div class="wishlist-switch-card current">

      <div class="wishlist-switch-card-header">
        <div class="wishlist-switch-header-left">
          <span class="wishlist-switch-mini-icon">
            🚗
          </span>
          <div class="wishlist-switch-header-text">
            <small class="wishlist-switch-crnt-car">CURRENT CAR IN REQUEST WISHLIST</small>
            <h3>{{ currentCarLabel }}</h3>
          </div>
        </div>
        <span class="wishlist-switch-tag">Items in Wishlist</span>
      </div>

      <div class="wishlist-switch-card-details">
        <div>
          <small>Items</small>
          <strong>{{ currentWishlistItems }} {{ currentWishlistItems === 1 ? 'Part' : 'Parts' }}</strong>
        </div>
        <div>
          <small>Status</small>
          <strong class="wishlist-switch-blue-text">
              Items Added
            </strong>
            <!-- <div class="wishlist-switch-status-note">
               {{ currentWishlistItemNames }}
          </div> -->
        </div>
      </div>

    </div>

    <!-- Divider -->
    <div class="wishlist-switch-divider-wrap">
      <span class="wishlist-switch-dash top"></span>
      <div class="wishlist-switch-divider-circle">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M12 4v16m0 0l-6-6m6 6l6-6" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="wishlist-switch-dash top"></span>
      <span class="wishlist-switch-dash-label">
        To add items for the new car,<br>
        replace the current wishlist
      </span>
    </div>

  <!-- New Car -->
  <div class="wishlist-switch-card new">

    <div class="wishlist-switch-card-header">
      <div class="wishlist-switch-header-left">
        <span class="wishlist-switch-mini-icon">
          🚗
        </span>
        <div class="wishlist-switch-header-text">
          <small class="wishlist-switch-new-car">
            NEWLY SELECTED CAR
          </small>
          <h3>{{ newCarLabel }}</h3>
        </div>
      </div>
      <span class="wishlist-switch-tag green">
        No Items Yet
      </span>
    </div>

    <div class="wishlist-switch-card-details">
      <div>
        <small>Item</small>
        <strong>1 {{ 1 === 1 ? 'Part' : 'Parts' }}</strong>
      </div>
      <div>
        <small>Status</small>
        <strong class="wishlist-switch-green-text">Ready to Add</strong>
        <!-- <div class="wishlist-switch-status-note">
          {{ newWishlistItemNames }}
        </div> -->
      </div>
    </div>

  </div>

  </div>

  <!-- Fixed Footer -->
  <div class="wishlist-switch-footer">
    <button class="wishlist-switch-replace-btn" (click)="replaceWishlist()">
      Replace Wishlist with {{ newCarLabel }}
    </button>

    <button class="wishlist-switch-keep-btn" (click)="keepCurrentWishlist()">
      Keep Current Wishlist ({{ currentCarLabel }})
    </button>
  </div>

  
</div>
